import React from "react";
import RadioIcon from "./icon/RadioIcon";
import "./RadioInput.css";

const RadioInput = (props) => {
  return (
    <React.Fragment>
      <div className="radio-input">
        {props.data
          ? props.data.map((d) => (
              <div className="radio-option" key={props.name + "_" + d.id}>
                <label htmlFor={props.name + "_" + d.id}>
                  <RadioIcon
                    isSelected={
                      props.incomingValue === d.backendValue ? true : false
                    }
                  />
                  <input
                    type="radio"
                    name={props.name}
                    id={props.name + "_" + d.id}
                    value={d.backendValue}
                    onChange={() => props.onChange(d.backendValue)}
                    checked={
                      props.incomingValue === d.backendValue ? true : false
                    }
                  />
                  {d.value}
                </label>
              </div>
            ))
          : null}
      </div>
    </React.Fragment>
  );
};

export default RadioInput;
